import { FC } from 'react'

import BasicTag from 'components/tags/basic-tag/basic-tag'

import { TypeCodes, MaterialTypes } from 'constants/data'
import { MaterialsColor, MaterialsType } from './constants'

interface ICardCategory {
  materialType?: MaterialTypes
  ArticleTypeId?: number
}

export const defineMaterialType = (materialType?: MaterialTypes, ArticleTypeId?: number) => {
  if (materialType === MaterialTypes.FUTURE_WEBINAR) return MaterialsType.WEBINAR
  if (materialType === MaterialTypes.WEBINAR) return MaterialsType.WEBINAR_PAST
  if (materialType === MaterialTypes.PODCAST) return MaterialsType.PODCAST
  if (ArticleTypeId === TypeCodes.VIDEO) return MaterialsType.VIDEO
  if (ArticleTypeId === TypeCodes.ARTICLE) return MaterialsType.ARTICLE
  if (ArticleTypeId === TypeCodes.CLINIC) return MaterialsType.CLINIC
  if (ArticleTypeId === TypeCodes.CLINIC_CASE) return MaterialsType.CLINIC_CASE
  return ''
}

const CardCategory: FC<ICardCategory> = ({ materialType, ArticleTypeId }: ICardCategory) => {
  const category = defineMaterialType(materialType, ArticleTypeId)
  const themeColor = MaterialsColor[category]

  return <BasicTag themeColor={themeColor}>{category}</BasicTag>
}

export default CardCategory
